import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { Box } from '@eatclubapp/ec-component-library';
import useHeaderStyles from '../../components/layout/appHeader/HeaderStyles';
import usePosStyles from './PosIntegrationPageTitleStyles';
import { formatDate } from '../../utils/helpers';
import PosConnectedIcon from '../../assets/icons/pos_connected.svg';

const PosIntegrationPageTitle = ({ posStatus }) => {
  const headerClasses = useHeaderStyles();
  const posClasses = usePosStyles();

  const isConnected = posStatus.data?.status === 'connected';

  if (!isConnected) {
    return (
      <Typography variant='h1' className={headerClasses.title}>
        Integrate your Point of Sale
      </Typography>
    );
  }

  const posLogoUrl = posStatus.data?.posLogoUrl || null;
  const posLogoName = posStatus.data?.system || 'N/A';
  const lastUpdateDate = formatDate(posStatus.data?.lastUpdated, 'D/M/YY', 'N/A');

  return (
    <Box className={posClasses.root}>
      <Box className={posClasses.leftSection}>
        <Typography variant='h1' className={headerClasses.title}>
          POS Integration
        </Typography>
        <Box className={posClasses.logoBadge}>
          {posLogoUrl && (
            <img src={posLogoUrl} alt={posLogoName} className={posClasses.logoImage} />
          )}
        </Box>
      </Box>
      <Box className={posClasses.rightSection}>
        <Box className={posClasses.lastUpdateContainer}>
          <span className={posClasses.lastUpdateText}>
            Last Menu Update:
            <span className={posClasses.lastUpdateDate}>{lastUpdateDate}</span>
          </span>
        </Box>
        <Box className={posClasses.statusBadge}>
          <Box className={posClasses.statusIcon}>
            <PosConnectedIcon width='20' height='20' />
          </Box>
          <p className={posClasses.statusText}>Connected</p>
        </Box>
      </Box>
    </Box>
  );
};

PosIntegrationPageTitle.propTypes = {
  posStatus: PropTypes.shape({
    data: PropTypes.shape({
      status: PropTypes.string,
      posLogoUrl: PropTypes.string,
      system: PropTypes.string,
      lastUpdated: PropTypes.string,
    }),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  posStatus: state.posStatus,
});

export default connect(mapStateToProps)(PosIntegrationPageTitle);
